<template>
  <!-- Скелет раздела каталога на время загрузки: переливаются блоки целиком
       (st-skel-block). Внутри — та же разметка, что у CatalogSection /
       ProductCard, с теми же классами и текстом-заглушкой; она скрыта и только
       задаёт размеры, поэтому пропорции совпадают с настоящими блоками -->
  <section class="st-section" aria-busy="true" aria-label="Загрузка предложений">
    <!-- шапка той же разметки, что в CatalogSection: заголовок + количество,
         «Смотреть все» и подзаголовок — каждый блоком по своему размеру -->
    <div class="st-section__head">
      <div class="st-section__title st-skel-block">
        <h2 class="st-heading">Спецпредложения</h2>
        <span class="st-section__count">00</span>
      </div>
      <span class="st-skel-block st-skel-link">
        <span class="st-link-all"
          ><span class="st-link-all__long">Смотреть все</span
          ><span class="st-link-all__short">Все</span> <ArrowIcon
        /></span>
      </span>
      <p class="st-section__sub st-skel-block">
        <span>Особые условия от партнёров</span>
      </p>
    </div>

    <div class="st-grid">
      <article v-for="n in count" :key="n" class="st-product st-skel-block">
        <div class="st-product__media"></div>
        <div class="st-product__body">
          <span class="st-product__title">Название позиции</span>
          <div class="st-note">Марка · модель</div>
          <div class="st-product__foot">
            <span class="st-amount">0 000 000 ₽</span>
            <span class="st-btn st-btn--base">Оформить онлайн</span>
          </div>
        </div>
      </article>
    </div>
  </section>
</template>

<script>
import ArrowIcon from "./ArrowIcon.vue";

export default {
  name: "CatalogSkeleton",
  components: { ArrowIcon },
  props: {
    // карточек в скелете — один ряд сетки
    count: { type: Number, default: 3 },
  },
};
</script>
